export enum LocationType {
  InPersonMeeting = 'physical',
  OutboundCall = 'outbound_call',
  InboundCall = 'inbound_call',
  GoogleConference = 'google_conference',
  ZoomConference = 'zoom_conference',
  GoToMeetingConference = 'gotomeeting',
  MicrosoftTeamsConference = 'microsoft_teams_conference',
  CustomLocation = 'custom',
  InviteeSpecifiedLocation = 'ask_invitee'
}
